export default __webpack_public_path__ + "static/media/euro-institute.6b69e918.webp";